import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { getPlatform } from "api/methods";
import { YouAreNotAlone } from "modules/personalisation/components/YouAreNotAlone";
import { HeritageContainer_PATH } from "modules/personalisation/containers/HeritageContainer";
import { usePersonalisationData } from "modules/personalisation/context/PersonalisationDataContext";

export const YouAreNotAloneContainer_PATH = "/personalise/you-are-not-alone" as const;

export const YouAreNotAloneContainer = () => {
  const navigate = useNavigate();
  const { advisorIdentity } = usePersonalisationData();

  const { data: platform } = useQuery({ ...getPlatform.keyed() });

  return (
    <YouAreNotAlone
      adonisIdentity={advisorIdentity}
      platformDetails={{
        logoSrc: platform?.logoImageUrl || "",
        platformName: platform?.name || "",
      }}
      onNext={() => navigate(HeritageContainer_PATH)}
    />
  );
};
